import { Row, Col, Button } from "react-bootstrap";

import { FaPlus } from "react-icons/fa";

const TitleDrag = ({ title }) => {
  return (
    <Row className="dragHere">
      <Col
        md={12}
        className="drag-n-drop shadow rounded text-center p-4 d-flex justify-content-center align-content-center align-items-center flex-column"
      >
        <h5>{title}</h5>
        <br />
        <div className="w-100 pt-3">
          <FaPlus size="2em" />
        </div>
      </Col>
    </Row>
  );
};

export default TitleDrag;
